import { render, staticRenderFns } from "./jt808-serv-combine-order-cancel-modal.vue?vue&type=template&id=10bd48cf"
import script from "./jt808-serv-combine-order-cancel-modal.vue?vue&type=script&lang=js"
export * from "./jt808-serv-combine-order-cancel-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports